(() => {
  const SHOP_PATH = '/collections/shop';
  const ALL_PATH = '/collections/all';

  const redirectAllProducts = () => {
    if (window.location.pathname === ALL_PATH) {
      window.location.replace(`${SHOP_PATH}${window.location.search}${window.location.hash}`);
      return true;
    }
    return false;
  };

  if (redirectAllProducts()) return;

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('a[href="/collections/all"], a[href^="/collections/all?"], a[href^="/collections/all#"]').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);
        url.pathname = SHOP_PATH;
        link.href = `${url.pathname}${url.search}${url.hash}`;
      } catch (error) {
        link.href = SHOP_PATH;
      }
    });
  });
})();
